import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.auth;

export const userSelector = createSelector(getState, (state) => state.user);
export const isLoadingTwitchLogin = createSelector(getState, (state) => state.isLoadingLogin);

export const validationDataSelector = createSelector(getState, (state) => state.validationData);
export const accessDataSelector = createSelector(
  getState,
  (state) => state.validationData?.access || {}
);
export const isLoadingValidationSelector = createSelector(
  getState,
  (state) => state.isLoadingTokenValidation
);
